module.exports = __webpack_public_path__ + "img/63.18eca0bf.png";